import React, { useState, useEffect } from "react";
import Pagination from "../../../common/pagination";
import { Link, useNavigate } from "react-router-dom";
import _ from "lodash";
import { paginate } from "../../../utils/paginate";
import Table from "./../../../common/table";
import getService from "../../../services/getService";
import { CSVLink } from "react-csv";
import SearchBox from "./../../../common/searchBox";

const HeadingTable = () => {
  const [headings, setHeading] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const fetchHeading = async () => {
    const data = await getService.handleHeading();
    setHeading(data);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setCurrentPage(1);
  };

  const getPagedData = () => {
    let filtered = headings;
    if (searchQuery)
      filtered = headings.filter((m) =>
        m.title.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
    else filtered = headings;

    const heading = paginate(filtered, currentPage, pageSize);
    return { totalCount: headings.length, data: heading };
  };

  const { length: count } = headings;

  const { totalCount, data: heading } = getPagedData();

  const columns = [
    {
      key: "",
      label: "S.No",
      content: (heading) => <p>{headings.indexOf(heading) + 1}</p>,
    },
    { path: "title", label: "Title" },
    {
      key: "Action",
      label: "Action",
      content: (heading) => (
        <>
          <button
            class="btn btn-info btn-xs m-b-5 custom_btn"
            onClick={() => {
              navigate(`/admin/headingform/${heading.id}`);
            }}
          >
            <i class="pe-7s-note" aria-hidden="true"></i>
          </button>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchHeading();
  }, []);

  if (count === 0) return <p>There are no item in the database.</p>;

  return (
    <>
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-bd lobidrag">
            <div class="panel-heading">
              <div class="panel-title">
                <h4>Heading List </h4>
              </div>
              <CSVLink data={headings} className="btn btn-outline-success">
                Download Report
              </CSVLink>
            </div>
            <div class="row">
              <div class="col-sm-7">
                <SearchBox value={searchQuery} onChange={handleSearch} />
              </div>
            </div>
            <div class="panel-body">
              <Table columns={columns} data={heading} />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-5">
          <div
            class="dataTables_info"
            id="supplierList_info"
            role="status"
            aria-live="polite"
          >
            Showing {totalCount} entries in the Database
          </div>
        </div>
        <div class="col-sm-7">
          <Pagination
            itemsCount={totalCount}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default HeadingTable;
